

export const ongoehvProjects = [
    
    {
        id:1,
        photoIcon: [
            "./ongoing/Ongo_1.jpeg", "./ongoing/Ongo_1_1.jpeg","./ongoing/Ongo_1_2.jpeg"
        ],
        client: "HITACHI ENERGY INDIA LTD",
        customer:"HPCL Rajasthan Refinery Ltd (HRRL)",
        location:"BARMAR, RAJASTHAN",
        project:"INSTALLATION AND COMMISSIONING SUPPORT SERVICES FOR 220/66KV AIS PKG."
    },
    {
        id:2,
        photoIcon: [
            "./ongoing/Ongo_34.jpeg", "./ongoing/Ongo_34_1.jpeg","./ongoing/Ongo_34_2.jpeg","./ongoing/Ongo_34_3.jpeg",
        ],
        client: "GE T&D INDIA LTD",
        customer:"KSEB Vizhinjam & Ettumanoor",
        location:"KERALA",
        project:"INSTALLATION AND COMMISSIONING SUPPORT SERVICES FOR 220 KV GIS PROJECT"
    },
    {
        id:3,
        photoIcon: [
            "./ongoing/Ongo_33.jpg", "./ongoing/Ongo_33_1.jpg","./ongoing/Ongo_33_2.jpg",
        ],
        client: "HITACHI ENERGY INDIA LTD",
        customer:"PGCIL",
        location:"RAIGARH",
        project:"INSTALLATION AND COMMISSIONING SUPPORT SERVICES FOR PGCIL RP 800 HVDC TERMINAL."
    },
    
    {
        id:4,
        photoIcon: [
            "./ongoing/Ongo_7.jpg", 
        ],
        client: "HITACHI ENERGY INDIA LTD",
        customer:"Bharat Aluminium Company Limited",
        location:"KORBA(C.G)",
        project:"Dismantling, Erection & commissioning services for 400/220KV GIS and AIS, BALCO"
    },
    
    
]